import React, { useState, useEffect } from 'react';

import { ReactComponent as ParcelsDueDate } from '../../../../assets/novosicones/Renegociacao/event_black_24dp.svg';

import DropDown from '../../../Reutilizaveis/DropDown';

import { Item, ItemContent } from './styles.js';

const VencimentoParcelas = ({ estilo, tema, regras, setRegras }) => {
  const [vencimentoParcela, setVencimentoParcela] = useState(
    regras?.vencimentoParcelas
  );
  const getExpirationOptions = () => [
    { nome: 'Todo dia 01 (um)', id: '1' },
    { nome: 'Todo dia 05 (cinco)', id: '5' },
    { nome: 'Todo dia 10 (dez)', id: '10' },
    { nome: 'Todo dia 15 (quinze)', id: '15' },
  ];

  useEffect(() => {
    setRegras({ ...regras, vencimentoParcelas: vencimentoParcela });
  }, [vencimentoParcela]);

  return (
    <Item>
      <span>
        <b>Vencimento das parcelas:</b>
      </span>
      <ItemContent>
        <ParcelsDueDate
          className='iconeRenegociacao'
          style={
            vencimentoParcela
              ? { fill: tema.primaryColor }
              : { fill: '#4d4d4d' }
          }
        />
        <DropDown
          itens={getExpirationOptions()}
          idDropDown={'ListaVencimentoParcela'}
          nomeDropDown='Selecione o melhor dia'
          setValue={setVencimentoParcela}
          style={{ margin: 0, border: 0 }}
          renegociacao
          renegociacaoWidth={estilo}
        />
      </ItemContent>
    </Item>
  );
};

export default VencimentoParcelas;
